import { JSONParser } from 'lincd-jsonld/utils/JSONParser';
import { JSONLD } from 'lincd-jsonld/utils/JSONLD';
import { setRequestData } from './RequestData.js';
import { LinkedStorage } from 'lincd/utils/LinkedStorage';
export function initFrontend() {
    var _a;
    //parse incoming data, put it into the default storage graph (so that if we change this data the changes will be pushed back to the store it came from)
    return Promise.all([
        JSONParser.parse(document.getElementById('request-json').innerText, LinkedStorage.getDefaultStorageGraph()),
        JSONLD.parseString((_a = document.getElementById('request-ld')) === null || _a === void 0 ? void 0 : _a.innerText, true, null, LinkedStorage.getDefaultStorageGraph()),
    ]).then(([parseResult]) => {
        setRequestData(parseResult);
    });
}
//# sourceMappingURL=Frontend.js.map